import { authClientOptions } from '@/pages/api/auth/[...nextauth]';
import { GetServerSideProps } from 'next';
import { getServerSession } from 'next-auth';
import authUtils from 'utils/auth';
import { ClientSignUpScreen } from '@/components/screens/auth/client-signup';

const Register = (): JSX.Element => {
	return <ClientSignUpScreen />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
	let redirectPath = undefined;

	const session = await getServerSession(
		context.req,
		context.res,
		authClientOptions
	);

	const role = session?.user.user?.role;
	if (session && session.user && role && role === 'client')
		redirectPath = {
			destination: authUtils.getPathToRedirectLoggedClient(),
			permanent: false,
		};

	context.res.setHeader('Cache-Control', 'private, no-cache, must-revalidate');

	return {
		props: {},
		redirect: redirectPath,
	};
};

export default Register;
